<div class="js-two-factor-timer-wrapper">
    <p v-if="showTimer" class="paragraph js-timer-countdown timer-text">
        {{ gettext('Повторно запросить код можно через:') }} {{ timerMinutes }}:{{ timerSeconds }}
    </p>

    <p v-else-if="showLimitMessage" class="paragraph js-timer-limit info-text timer-text">
        {{ gettext('Лимит запросов исчерпан. Операция будет доступна') }} {{ limitDate }} {{ gettext('в') }} {{ limitTime }}
    </p>
</div>
